import { ShiftDifferentialType } from '~/types/hlx/enums';
import { MsaasDetail } from '~/types/hlx/msaasDetail';
import { checkIfShiftDetails } from '../cost-calculator/utils';

export const formatShiftDistributionStr = (
  dayShifts: number | null,
  eveShifts: number | null,
  nightShifts: number | null
) => {
  if (dayShifts === null || eveShifts === null || nightShifts === null) {
    return 'Not Provided';
  }
  return `${dayShifts + eveShifts + nightShifts} (${dayShifts} Day, ${eveShifts} Evening, ${nightShifts} Night)`;
};

export const calculateDiffCost = (msaasDetail: MsaasDetail) => {
  const hasShiftDetails = checkIfShiftDetails(msaasDetail);
  if (!hasShiftDetails) {
    return 0;
  }
  const diffCostMappings = [
    { num: msaasDetail.numHolDayShifts, diff: msaasDetail.holDayShiftRateDiff },
    { num: msaasDetail.numHolEveShifts, diff: msaasDetail.holEveShiftRateDiff },
    { num: msaasDetail.numHolNightShifts, diff: msaasDetail.holNightShiftRateDiff },
    { num: msaasDetail.numOfWeDayShifts, diff: msaasDetail.weDayShiftRateDiff },
    { num: msaasDetail.numOfWeEveShifts, diff: msaasDetail.weEveShiftRateDiff },
    { num: msaasDetail.numOfWeNightShifts, diff: msaasDetail.weNightShiftRateDiff },
    { num: msaasDetail.numEveShifts, diff: msaasDetail.eveShiftRateDiff },
    { num: msaasDetail.numNightShifts, diff: msaasDetail.nightShiftRateDiff },
  ];
  const diffCost = diffCostMappings.reduce((acc, cur) => {
    const pricePerHour = Number(msaasDetail.pricePerHour ?? 0);
    let diffValue =
      msaasDetail.shiftDiffType === ShiftDifferentialType.INCR_HOURLY_RATE
        ? Number(cur.diff ?? 0)
        : Number(cur.diff ?? 1) * pricePerHour;
    diffValue = diffValue > 0 ? diffValue - pricePerHour : 0;
    return acc + diffValue * Number(msaasDetail.hoursPerShift ?? 0) * Number(cur.num ?? 0);
  }, 0);
  return diffCost;
};
